import { render, staticRenderFns } from "./IconBankCheck.vue?vue&type=template&id=4ea50f31&"
import script from "./IconBankCheck.vue?vue&type=script&lang=js&"
export * from "./IconBankCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports